export enum keyboard {
    ARROW_DOWN = 'ArrowDown',
    ARROW_UP = 'ArrowUp',
    ARROW_LEFT = 'ArrowLeft',
    ARROW_RIGHT = 'ArrowRight',
    BACKSPACE = 'Backspace',
    END = 'End',
    ENTER = 'Enter',
    ESCAPE = 'Escape',
    HOME = 'Home',
    SPACE = 'Space',
    TAB = 'Tab',
    NUMPAD_ENTER = 'NumpadEnter',
    NUMPAD_8 = 'Numpad8',
    NUMPAD_2 = 'Numpad2',
}

export enum keyCode {
    ARROW_DOWN = 40,
    ARROW_LEFT = 37,
    ARROW_RIGHT = 39,
    ARROW_UP = 38,
    END = 35,
    ENTER = 13,
    ESCAPE = 27,
    HOME = 36,
    SPACE = 32,
    PAGEUP = 33,
    PAGEDOWN = 34,
    TAB = 9,
}
